import * as React from 'react'
import styled from 'styled-components'
import CollapseButton from 'src/components/atoms/input/buttons/Collapse'
import ContainerProps from './Resources'

interface Props extends ContainerProps {
  title: string
  defaultCollapsed?: boolean
}

interface State {
  collapsed: boolean
}

export default class AccordionContainer extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    const { defaultCollapsed } = this.props
    this.state = {
      collapsed: defaultCollapsed
    }
  }

  render() {
    const { title, children, defaultCollapsed } = this.props
    const { collapsed } = this.state
    return (
      <Container>
        <Header>
          <h3>{title}</h3>
          <CollapseButton
            defaultCollapsed={defaultCollapsed}
            onClick={(c) => this.setState({ collapsed: c })}
          />
        </Header>
        <Content collapsed={collapsed}>{children}</Content>
      </Container>
    )
  }
}

const Container = styled.div`
  width: 100%;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 7.5px;
  padding: 5px 7.5px;
  background-color: #d5e4e6;
  h3 {
    display: inline;
    font-size: 16px;
    text-align: left;
    font-weight: bold;
    margin: 0;
  }
`

const Content = styled.div`
  height: ${(props) => (props.collapsed ? '0' : 'auto')};
  padding: ${(props) => (props.collapsed ? '0 7.5px' : '5px 7.5px')};
  overflow: hidden;
`



// WEBPACK FOOTER //
// ./src/components/containers/Accordion.tsx